module.exports = __webpack_public_path__ + "static/map_bg_texture_fizz_gray-6bcb3015bc8443ff5b53f902966d96c6.png";